import React, { useState } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import AccessSessionProp from '../../../commonComponents/propTypes/accessSessionProp';
import UpcomingSessionItem from './UpcomingSessionItem';
import UpcomingSessionsCalendar from './UpcomingSessionsCalendar';

function UpcomingSessionsSection({ t, upcomingSessions }) {
  const [stateUpcomingSessions, setStateUpcomingSessions] = useState(upcomingSessions);
  const sessionList = stateUpcomingSessions.map(session => ({
      startDate: session.startDate,
      endDate: session.endDate || session.startDate,
      title: session.name,
      summary: session.summary || null,
      slug: session.slug,
  }));

  return (
    <div className="row">
      <div className="col-12 col-lg-8">
        <div className="m-portlet m-portlet--rounded m-portlet--rounded-force calendar-max-fixed-size">
          <div className="m-portlet__head upcoming-session-header">
            <div className="m-portlet__head-caption pb-1">
              <div className="m-portlet__head-title">
                <h3 className="m-portlet__head-text">{t('inbox_upcoming_sessions')}</h3>
              </div>
            </div>
          </div>
          <div className="m-portlet__body scrollable pt-1">
            { sessionList.length > 0 &&
              sessionList.map((session, index) => (
                <UpcomingSessionItem
                  session={session}
                  isLast={(index + 1 === sessionList.length)}
                />
              ))
            }
            { !sessionList.length > 0 && (
              <div className="row my-4 no-upcoming-sessions-container vertical-center">
                <div className="col-4 text-right">
                  <i className="fas fa-exclamation-circle no-upcoming-sessions-icon" />
                </div>
                <div className="col-8">
                  <h5>{t('inbox_no_upcoming_sessions')}</h5>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-4">
        <div className="m-portlet m-portlet--rounded m-portlet--rounded-force calendar-max-fixed-size">
          <div className="m-portlet__body">
            <UpcomingSessionsCalendar
              t={t}
              upcomingSessions={upcomingSessions}
              navigation={setStateUpcomingSessions}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

UpcomingSessionsSection.propTypes = {
  t: PropTypes.func.isRequired,
  upcomingSessions: PropTypes.arrayOf(PropTypes.shape(AccessSessionProp.propType)).isRequired,
};

export default translate(UpcomingSessionsSection);
